/** Immutable CDN bundle identity sent with SDK calls for safe endpoint retirement. */
export const ZIPPER_EMBED_BUNDLE_ID = "zipper-embeds-v1";
export const ZIPPER_EMBED_BUNDLE_VERSION = "0.1.0";
